import React from 'react';
import { ModalWindow } from 'components/modal-window/modal-window';
import { FormConfirmSms2fa } from 'src/components/forms/form-confirm-sms-2fa/form-confirm-sms-2fa';
import { MODAL_CONFIRM_PHONE_CLASS, MODAL_IDS } from '../../../constants';

export const ConfirmSms2faModal = () => (
  <ModalWindow
    id={MODAL_IDS.CONFIRM_SMS_2FA}
    coreProps={{ id: MODAL_IDS.CONFIRM_SMS_2FA }}
    classForDocumentBody={MODAL_CONFIRM_PHONE_CLASS}
    bodyClassName="pb-6"
    fade
  >
    <FormConfirmSms2fa />
  </ModalWindow>
);

